import React, {Fragment, useEffect} from 'react';
import {Link, Icons, Breadcrumbs, PageLock} from 'components';
import {api} from 'helpers';
import {store} from 'store';

export function MembershipStatus(props) {
  useEffect(() => {
    (async function(){
      const { status } = await api('/finish-payment/');

      if (status == 'Completed') {
        return store.dispatch({
          type: 'SERVER_READ',
          full: true,
          historyPush: '../upgraded/',
        });
      }

      store.dispatch({
        type: 'UI_ERROR',
        errorMessage: 'An error has occurred during the processing of the transaction. Please try again later.',
        historyPush: '../',
      });

    })();
  }, []);

  return (
    <Fragment>
      <PageLock />
      <Breadcrumbs>
        <Link to="/settings/">Settings</Link>
        <Link to="/settings/membership/">Membership</Link>
        <b>Processing</b>
      </Breadcrumbs>
      <p><Icons.Spinner /> Your payment is being processed. Please wait.</p>
    </Fragment>
  );

}
